import React from 'react';
import { Box, Typography, Grid, Avatar } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const About = () => {
  const boardMembers = [
    { name: 'Biplob Bhandari', position: 'President', image: 'board_members/biplob.jpg' },
    { name: 'Rupesh Basnet', position: 'Vice President', image: 'board_members/rupesh.jpg' },
    { name: 'Bigyan Gautam', position: 'Secretary', image: 'board_members/bigyan.jpg' },
    { name: 'Prashant Kumar Shah', position: 'Treasurer', image: 'board_members/prashant.jpg' },
    { name: 'Aayush Kafle', position: 'Board Member', image: 'board_members/aayush.jpg' },
    { name: 'Bhupendra Basnet', position: 'Board Member', image: 'board_members/bhupendra.jpg' },
    { name: 'Prakash Adhikari', position: 'Board Member', image: 'board_members/pamit.jpg' },
  ];

  return (
    <>
      <Helmet>
        <title>About Us - Mirmire</title>
        <meta name="description" content="Learn about Mirmire's history and board members" />
      </Helmet>

      {/* About Us Header Section */}
      <Box
        sx={{
          bgcolor: '#000000',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: '#FFD700',
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            textAlign: 'center',
          }}
        >
          ABOUT US
        </Typography>
      </Box>

      {/* Our History Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '1000px',
            px: 2,
          }}
        >
          <Typography
            variant="h2"
            gutterBottom
            sx={{
              color: '#FFD700',
              fontWeight: 700,
              fontSize: '2.5rem',
              mb: 3,
            }}
          >
            OUR HISTORY
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#000000',
              fontSize: '1.1rem',
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            Mirmire Sporting Club was founded in 2023 by a group of like-minded Nepalese football
            enthusiasts in Finland. What began as a shared passion among friends quickly evolved
            into a growing club with over 50 active members. <br />
            <br />
            The club's mission extends beyond the game — Mirmire SC is committed to promoting{' '}
            <b>brotherhood, physical and mental well-being</b>, and building a strong, connected
            community through football.
            <br />
            <br />
            Since its founding, Mirmire SC has grown in both size and ambition. The club trains
            regularly, participates in local competitions, and has already achieved notable success
            — <b>winning the Gaule Cup in both 2023 and 2024</b>, and finishing as{' '}
            <b>runner-up in the MAMC 2024</b>, a tournament proudly organized by the club itself.{' '}
            <br />
            <br />
            With unity and discipline at its core, Mirmire SC continues to strive forward — on the
            pitch and beyond.
          </Typography>
        </Box>
      </Box>

      {/* Board Members Section */}
      <Box
        sx={{
          bgcolor: '#FFFFFF',
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: 'center',
          borderTop: '1px solid #E0E0E0',
        }}
      >
        <Box
          sx={{
            width: '1000px',
            px: 2,
          }}
        >
          <Typography
            variant="h2"
            gutterBottom
            sx={{
              color: '#FFD700',
              fontWeight: 700,
              fontSize: '2.5rem',
              mb: 4,
            }}
          >
            BOARD MEMBERS
          </Typography>
          <Grid container spacing={3}>
            {boardMembers.map((member, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    bgcolor: '#000000',
                    p: 2,
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Avatar
                    src={member.image}
                    sx={{
                      width: 140,
                      height: 140,
                      bgcolor: '#333333',
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#FFFFFF',
                      fontWeight: 600,
                      mb: 1,
                    }}
                  >
                    {member.name}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: '#FFD700',
                    }}
                  >
                    {member.position}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default About;
